module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_troms_og_finnmark_neg.db3d1216.pdf";